import React from "react";
import { Card, CardBody } from "reactstrap";
import { FiAlertTriangle } from "react-icons/fi";

// Corrected prop name from Massage → message
function Livealerts_cards({ message, ecamno, Time, cameratype }) {
  return (
    <Card>
      <CardBody
        style={{
          padding: "20px 10px",
          border: "1px solid #FECACA",
          borderRadius: "8px",
        }}
      >
        <div className="d-flex gap-2">
          <FiAlertTriangle style={{ fontSize: "16px", color: "#DC2626" }} />
          <div style={{ overflow: "hidden" }}>
            <h2
              className="ellipsis-text"
              style={{
                fontSize: "14px",
                fontWeight: 500,
                width: "100%",
              }}
            >
              {message} person detected
            </h2>

            <p style={{ fontSize: "12px", color: "#4B5563" }}>
              Camera Name: {ecamno} • {Time}
            </p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default Livealerts_cards;
